import { SavedSearchRequest } from '@doda/api-client/aspida/@types';
import { createDataToJpDateFormat } from '@doda/common/src/utils/dateUtil';
import { SelectedCurrentConditionType } from 'types/searchCondition';

/**
 * 検索条件保存APIのリクエストを生成
 * @param conditions 選択中の検索条件
 * @returns 検索条件保存APIのリクエスト
 */
export const createSaveConditionsRequest = (
  conditions: SelectedCurrentConditionType
): SavedSearchRequest => {
  return {
    name: `${createDataToJpDateFormat()}の検索条件`,
    areaIdList: conditions.areaId.map(Number),
    prefectureIdList: conditions.prefectureId.map(Number),
    cityIdList: conditions.cityId,
    wardIdList: conditions.wardId,
    routeIdList: conditions.routeId,
    stationIdList: conditions.stationId,
    searchJobTypeLIdList: conditions.searchJobTypeLId,
    searchJobTypeMIdList: conditions.searchJobTypeMId,
    searchJobTypeSIdList: conditions.searchJobTypeSId,
    industryLIdList: conditions.industryLId,
    industrySIdList: conditions.industrySId,
    includedKeywordCategory: conditions.includedKeywordCategory,
    includedKeywordList: conditions.includedKeyword,
    excludedKeywordCategory: conditions.excludedKeywordCategory,
    excludedKeywordList: conditions.excludedKeyword,
    isNewArrival: conditions.isNewArrival,
    isNearDeadline: conditions.isNearDeadline,
    employmentStatusList: conditions.employmentStatus,
    holidayAndWayOfWorkingList: conditions.holidayAndWayOfWorking,
    requirementsList: conditions.requirements,
    workplaceEnvironmentList: conditions.workplaceEnvironment,
    welfareBenefitsList: conditions.welfareBenefits,
    languageSkillsList: conditions.languageSkills,
    positionsList: conditions.positions,
    employeeAverageAgeList: conditions.employeeAverageAge,
    establishList: conditions.establish,
    employNumList: conditions.employNum,
    lowerLimitIncome: conditions.lowerLimitIncome,
    upperLimitIncome: conditions.upperLimitIncome,
    jobOfferKind: conditions.jobOfferKind,
  };
};
